const NflSecondaryStackCombinations = {
    SECONDARY_STACK_COMBINATION_TYPE_1: 1,
    SECONDARY_STACK_COMBINATION_TYPE_2: 2,
    SECONDARY_STACK_COMBINATION_TYPE_3: 3,
    SECONDARY_STACK_COMBINATION_TYPE_4: 4,
    SECONDARY_STACK_COMBINATION_TYPE_5: 5,
};

NflSecondaryStackCombinations.SECONDARY_STACK_COMBINATION_TYPE_LABELS = {
    [NflSecondaryStackCombinations.SECONDARY_STACK_COMBINATION_TYPE_1]: 'RB + Opposing team pass catcher (WR,TE)',
    [NflSecondaryStackCombinations.SECONDARY_STACK_COMBINATION_TYPE_2]: 'WR + Opposing team pass catcher (WR,TE)',
    [NflSecondaryStackCombinations.SECONDARY_STACK_COMBINATION_TYPE_3]: 'RB + WR same team',
    [NflSecondaryStackCombinations.SECONDARY_STACK_COMBINATION_TYPE_4]: 'RB + DEF same team',
    [NflSecondaryStackCombinations.SECONDARY_STACK_COMBINATION_TYPE_5]:
        'Pass catcher (WR,TE) + pass catcher (WR,TE) same team',
};

// Symbol `|` means players from the opposite teams, `+` means from the same.
NflSecondaryStackCombinations.SECONDARY_STACK_COMBINATION_TYPES = {
    // 1 - RB|(WR,TE).
    [NflSecondaryStackCombinations.SECONDARY_STACK_COMBINATION_TYPE_1]: {
        mainTeamPositions: ['RB'],
        opponentTeamPositions: ['WR', 'TE'],
    },
    // 2 - WR|(WR,TE).
    [NflSecondaryStackCombinations.SECONDARY_STACK_COMBINATION_TYPE_2]: {
        mainTeamPositions: ['WR'],
        opponentTeamPositions: ['WR', 'TE'],
    },
    // 3 - RB+WR.
    [NflSecondaryStackCombinations.SECONDARY_STACK_COMBINATION_TYPE_3]: {
        mainTeamPositions: ['RB', 'WR'],
        opponentTeamPositions: [],
    },
    // 4 - RB+DEF. (DEF, DST and D are synonyms)
    [NflSecondaryStackCombinations.SECONDARY_STACK_COMBINATION_TYPE_4]: {
        mainTeamPositions: ['RB', 'D', 'DEF', 'DST'],
        opponentTeamPositions: [],
    },
    // 5 - (WR,TE)+(WR,TE).
    [NflSecondaryStackCombinations.SECONDARY_STACK_COMBINATION_TYPE_5]: {
        mainTeamPositions: ['WR', 'TE'],
        opponentTeamPositions: [],
    },
};

export default NflSecondaryStackCombinations;
